import {
  COLOR,
  FONT_SIZE,
  TextLink as _TextLink,
  Select as _Select,
  Heading as _Heading,
  mq,
} from "@dmm-com/rocket-web-ui-library";
import styled from "@emotion/styled";
import { ROOT_PADDING } from "~/styles/padding";

export const HeadingSeasonTitle = styled(_Heading)`
  max-width: 672px;
  width: calc(100% - 32px);
  font-size: ${FONT_SIZE.LL}px;
  ${mq.sp} {
    width: calc(100% - 40px);
    font-size: ${FONT_SIZE.L}px;
  }
`;

export const DivRootGrid = styled.div`
  display: grid;
  grid-gap: 32px;
  padding: ${ROOT_PADDING.PC}px;
`;

export const SecFlexContainer = styled.section`
  display: flex;
  justify-content: space-between;
  align-items: center;
`;

export const DivButtonFlexContainer = styled.div<{ partLength: number }>`
  display: grid;
  grid-gap: 16px;
  grid-template-columns: ${({ partLength }) => {
    if (partLength === 2) return `repeat(2, 1fr);`;
    if (partLength > 3) return `repeat(3, 1fr);`;

    return `repeat(1, 1fr);`;
  }};
`;

export const DivDownloadGridContainer = styled.div`
  display: grid;
  grid-gap: 8px;
  padding: ${ROOT_PADDING.SP}px;
  border: 1px solid ${COLOR.GRAY200.code};
  border-radius: 8px;
`;

export const TextLink = styled(_TextLink)`
  display: inline-block;
  width: fit-content;
  font-size: ${FONT_SIZE.S}px;
`;

export const ParText = styled.p`
  font-size: ${FONT_SIZE.S}px;
`;

export const SpanText = styled.span`
  font-size: ${FONT_SIZE.S}px;
`;

export const Select = styled(_Select)`
  button {
    height: 40px;
  }
`;
